import React from "react";
import { FormControl, TextField } from "Components/Base/Inputs";

/**
 * DateFilter component provides a date input field wrapped in a FormControl
 * @param {Object} props - Component props
 * @param {string} props.label - Label text for the date input field
 * @param {string} props.value - Current date value (YYYY-MM-DD format)
 * @param {Function} props.onChange - Callback function called when date value changes
 * @param {string} props.name - Name identifier for the date filter field
 * @param {Object} [props.sx] - Additional sx styles to apply to the FormControl
 * @returns {JSX.Element} DateFilter component
 */
const DateFilter = ({ label, value, onChange, name, sx }) => {
  /**
   * Handles date input change events
   * @param {Event} event - Change event from the input field
   */
  const handleChange = (event) => {
    onChange(event, name, event.target.value);
  };

  return (
    <FormControl variant="outlined" fullWidth={true} sx={sx}>
      <TextField
        id={`date-filter-${name}`}
        label={label}
        type="date"
        value={value}
        onChange={handleChange}
        variant="outlined"
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        sx={{ width: "100%" }}
      />
    </FormControl>
  );
};

export default DateFilter;

